import { Select as NBSelect } from 'native-base';

import type { ISelectComponentType } from './Select.types';

const SelectTemp: any = NBSelect;
SelectTemp.Item = NBSelect.Item;

const Select = SelectTemp as ISelectComponentType;

export { Select };
export * from './Select.types';
